import React from "react";
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { css } from 'emotion';
import { listUnstyled, navItem, selectedNavLink, selectedNavItem, navLink } from './style';
import { publish } from "pubsub-js";
import eventType from "../../events/eventType";


const MyAccountNavItems = (props) => {

	const handleEvent = (menuLink) => {

		if (menuLink.event_type) {
			publish(eventType.ACCOUNT_FAMILY, {
				type: menuLink.event_type
			})
		}
		
		if(menuLink.title) {
			props.onClick(menuLink.title);
		}

	}

	return (
		<ul className={css`${listUnstyled}`}>
			{props.menuLinks.map((menuLink, index) => (
				<li className={css`${location.href.match(menuLink.address) === null ? navItem : selectedNavItem}`} key={index} onClick={() => handleEvent(menuLink)}>
					{menuLink.id !== props.ids.familyCount ?
						<>
							<NavLink
								to={menuLink.address}
								title={menuLink.title}
								className={css`${location.href.match(menuLink.address) === null ? navLink : selectedNavLink}`}
								data-action={menuLink.dataAction}
							>
								<div>
									{props.badgeCountPendent && menuLink.id === props.ids.registerData ? (
										<span className="badge-counter">{props.badgeCountPendent}</span>
									) : null}
									<i className={menuLink.icon}></i>
									{menuLink.title}
								</div>
							</NavLink>
						</>
						: menuLink.id === props.ids.familyCount && !!props.isManager &&
						<>
							<NavLink
								to={menuLink.address}
								title={menuLink.title}
								className={css`${location.href.match(menuLink.address) === null ? navLink : selectedNavLink}`}
								data-action={menuLink.dataAction}
							>
								<div>
									{props.badgeCountPendentManager ?
										<span className="badge-counter">{props.badgeCountPendentManager}</span>
										: null}
									<i className={menuLink.icon}></i>
									{menuLink.title}
									<span className="my-account--advanced-management--badge">NOVO</span>
								</div>
							</NavLink>
						</>
					}
				</li>
			))}
		</ul>
	)
}

const mapStateToProps = state => ({
	isManager: state.advancedManagement.userManager,
	badgeCountPendent: state.accountLink.badgeCountPendent,
	badgeCountPendentManager: state.advancedManagement.badgeCountPendent
});

export default withRouter(connect(mapStateToProps)(MyAccountNavItems));
